export default __webpack_public_path__ + "static/media/image.iterminal-technologies.c0c903c2.png";